
import { defineComponent, computed } from "vue";
import { useStore } from "vuex";
import { I18nUtils } from "@/sea/utils/I18nUtils";

export default defineComponent({
  name: "Loader",
  props: {
    logo: String,
  },
  setup() {
    const store = useStore();

    const loaderType = computed(() => {
      return store.getters.layoutConfig("loader.type");
    });

    return {
      loaderType,
      I18nUtils,
    };
  },
});
